import { IAddress } from 'app/shared/model/address.model';
import { ICustomerOrder } from 'app/shared/model/customer-order.model';
import { ProductOrderStatus } from 'app/shared/model/enumerations/product-order-status.model';

export interface IProductOrder {
  id?: number;
  quantity?: number | null;
  status?: keyof typeof ProductOrderStatus | null;
  serviceLocation?: IAddress | null;
  customerOrder?: ICustomerOrder | null;
}

export const defaultValue: Readonly<IProductOrder> = {};
